var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../js/filters/nunjucks-config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});




var shim = require("/jh/workspace/MonoWeb-Build-Release/monoweb/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["core/templates/partials/account-navigation-links-additional.j2"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
if(!runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"isSiteOutsideNorthAmerica")) {
output += "<li class=\"o-secondary-navigation__li\">\n    <a class=\"o-secondary-navigation__a ";
output += runtime.suppressValue((runtime.contextOrFrameLookup(context, frame, "registry")?"o-secondary-navigation__a--current":""), env.opts.autoescape);
output += "\" href=\"";
output += runtime.suppressValue((lineno = 3, colno = 118, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "registryUrl"), "registryUrl", context, [])), env.opts.autoescape);
output += "\" data-link-name=\"registry\" data-qa-my-account-nav=\"account_navigation-registry\">\n        ";
output += runtime.suppressValue((lineno = 4, colno = 9, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["account_navigation-registry",runtime.makeKeywordArgs({"state": runtime.contextOrFrameLookup(context, frame, "core")})])), env.opts.autoescape);
output += "\n    </a>\n</li>";
;
}
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["core/templates/partials/account-navigation-links-additional.j2"] , dependencies)